import React, { useContext, useEffect, useState } from 'react'
import { navigate } from 'gatsby'
import Loader from 'react-loader-spinner'

import img_title_top from '../../../assets/images/title_top.png'
import Button from '../../atoms/button/button'
import { Context } from '../../../context/app-context'
import userSessionStorage from '../../../utils/userSessionStorage'
import getUrlIdRegister from '../../../utils/getUrlIdRegister'
import { siteUrl } from '../../../shared/utils/siteUrl'

import gameServices from '../../../services/game-service'
import {
  topNumber,
  idsGameList,
  datesFaseActivities,
  activity_dates,
  LOCALE,
} from '../../../constants/activity-constants'

import { jsonToHash } from '../../../utils/crypto'
import { pushEventData } from '../../../utils/pushEventDataLayer'

import './content-top.scss'
import formatDateStr from '../../../utils/formatDateStr'
import {
  Text1ByCountry,
  textCountry,
  text_replica_content_top2,
  text_replica_content_top3,
  text_replica_content_top4,
} from './replica-content-top'

const arg = LOCALE === 'es-AR'

const ContentTop = () => {
  const { dispatch } = useContext(Context)
  const session = new userSessionStorage()

  const userInfo = session.getUserInfo()

  const [topWinnersFase1, setTopWinnersFase1] = useState([])
  const [topWinnersFase2, setTopWinnersFase2] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    getTop('fase1')
    getTop('fase2')
  }, [])
  const getStartDate = fase => {
    const forceUseFase1DatesAsRequested = true
    if (fase === 'fase1' || forceUseFase1DatesAsRequested) {
      return datesFaseActivities.datesTopFase1.startDate
    }
    return datesFaseActivities.datesTopFase2.startDate
  }
  const getTop = fase => {
    const payload = {
      idList: idsGameList,
      startDate: getStartDate(fase),
      endDate:
        fase === 'fase1'
          ? datesFaseActivities.datesTopFase1.endDate
          : datesFaseActivities.datesTopFase2.endDate,
      size: topNumber,
      page: 0,
      phase: fase === 'fase1' ? 0 : 1,
    }

    gameServices.getTopPaginationMoreGames(payload).then(res => {
      if (res.status === 200) {
        fase === 'fase1'
          ? setTopWinnersFase1(res.data.topGame)
          : setTopWinnersFase2(res.data.topGame)
        setIsLoading(false)
      }
    })
  }

  const handleDataLayer = async label => {
    pushEventData({
      event: 'Interacciones_TopJugadoras_UCole',
      action: 'click',
      label: label,
      user_data: userInfo && [
        await jsonToHash({
          nombre: userInfo.name,
          apellido: userInfo.lastName,
          celular: userInfo.cellPhone,
          correo: userInfo.email,
          ciudad: userInfo.location.cityName,
          departamento: userInfo.location.countryStateName,
          pais: userInfo.countryName,
        }),
      ],
      log_status: userInfo ? 'Yes' : 'Not',
    })
  }

  const handleLogin = () => {
    handleDataLayer('Inicia sesión')
    dispatch({
      type: 'set-modal',
      modalActive: {
        type: 'login',
        props: {
          close: () => {
            dispatch({ type: 'clear-modal' })
            // navigate('/')
          },
          handleSuccess: () => {
            // window.location.reload()
            dispatch({ type: 'clear-modal' })
            navigate('/perfil')
          },
          // mobile: isMobile,
        },
      },
    })
  }

  return (
    <div className="f-content-top-container">
      <section className="f-content-top-left">
        <div className="f-content-top-left__info-box">
          <img src={img_title_top} alt="titulo premios" />

          <p className={arg && `text-alig-arg`}>
            {text_replica_content_top3}
            <Text1ByCountry
              topNumber={topNumber}
              activity_dates={activity_dates[1]}
            />
            {!session.getUserInfo() && (
              <>
                <br />
                <a onClick={() => handleLogin()}>{textCountry.text1}</a>
                {text_replica_content_top4}
                <a
                  onClick={() => {
                    handleDataLayer('aquí')
                    window.open(siteUrl + getUrlIdRegister(), '_blank')
                  }}
                  rel="noreferrer"
                  target="_blank"
                >
                  {textCountry.text2}
                </a>
                <br />
              </>
            )}
            {text_replica_content_top2}
          </p>
        </div>
      </section>
      <section className="f-content-top-right">
        <div className="f-content-top-right__wrapper-info">
          <div className="f-content-top-right__wrapper-info__container">
            <span
              className={`f-content-top-right__wrapper-info__container__title`}
            >
              <h2>
                <b>Top</b> fase 1
              </h2>
              <p>
                {formatDateStr(
                  datesFaseActivities.datesTopFase1,
                  'Del $startDate.date $startDate.month al $endDate.date $endDate.month'
                )}
              </p>
            </span>
            <div className="f-content-top-right__wrapper-info__container__content-box">
              <span className="f-content-top-right__wrapper-info__container__content-box__header-list">
                <h3>Nombre</h3>
                <h3>Correo</h3>
              </span>

              <ol>
                {isLoading ? (
                  <div className="f-loader-container">
                    <Loader
                      type="Oval"
                      color="#15225f"
                      height={70}
                      width={70}
                    />
                  </div>
                ) : (
                  topWinnersFase1.map((item, index) => {
                    return (
                      <li key={'top' + index}>
                        <p>
                          <span>{index + 1}.</span> {item.name}
                        </p>
                        <p>{item.email}</p>
                      </li>
                    )
                  })
                )}
              </ol>
            </div>
          </div>
          <div className="f-content-top-right__wrapper-info__container">
            <span
              className={`f-content-top-right__wrapper-info__container__title`}
            >
              <h2>
                <b>Top</b> fase 2
              </h2>
              <p>
                {formatDateStr(
                  datesFaseActivities.datesTopFase2Front,
                  'Del $startDate.date $startDate.month al $endDate.date $endDate.month'
                )}
              </p>
            </span>
            <div className="f-content-top-right__wrapper-info__container__content-box">
              <span className="f-content-top-right__wrapper-info__container__content-box__header-list">
                <h3>Nombre</h3>
                <h3>Correo</h3>
              </span>
              <ol
                className={`${topWinnersFase2.length === 0 && 'f-text-center'}`}
              >
                {isLoading ? (
                  <div className="f-loader-container">
                    <Loader
                      type="Oval"
                      color="#15225f"
                      height={70}
                      width={70}
                    />
                  </div>
                ) : topWinnersFase2.length !== 0 ? (
                  topWinnersFase2.map((item, index) => {
                    return (
                      <li key={'top' + index}>
                        <p>
                          <span>{index + 1}.</span> {item.name}
                        </p>
                        <p>{item.email}</p>
                      </li>
                    )
                  })
                ) : (
                  <h3>La fase 2 aún no ha empezado.</h3>
                )}
              </ol>
            </div>
          </div>
        </div>
        <Button
          onClick={() => {
            handleDataLayer('¡Quiero jugar!')
            navigate('/jugar')
          }}
        >
          ¡Quiero jugar!
        </Button>
      </section>
    </div>
  )
}

export default ContentTop
